import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

class Select extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.id,
            name: this.props.name,
            options: this.props.options,
            onChange: this.props.onChange,
            openOnClick: this.props.openOnClick,
            clearable: this.props.clearable,
            disabled: this.props.disabled,
            searchable: this.props.searchable,
            labelKey: this.props.labelKey,
            valueKey: this.props.valueKey,
            noResultsText: this.props.noResultsText,
            placeholder: this.props.placeholder,
            selectedValue: this.props.selectedValue,
            required: this.props.required
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            id: nextProps.id,
            name: nextProps.name,
            onChange: nextProps.onChange,
            openOnClick: nextProps.openOnClick,
            clearable: nextProps.clearable,
            disabled: nextProps.disabled,
            searchable: nextProps.searchable,
            labelKey: nextProps.labelKey,
            valueKey: nextProps.valueKey,
            noResultsText: nextProps.noResultsText,
            placeholder: nextProps.placeholder,
            hasParent: nextProps.hasParent,
            parentValue: nextProps.parentValue,
            required: nextProps.required
        });

        if (this.props.hasParent === true && nextProps.parentValue === '') {
            this.setState({
                selectedValue: '',
                options: []
            });
        } else {
            this.setState({
                selectedValue: nextProps.selectedValue,
                options: nextProps.options
            });
        }
    }

    onChange(value) {
        let { name, valueKey, onChange } = this.state;

        onChange(name, value, valueKey);
    }

    render() {
        let {
            id,
            name,
            openOnClick,
            clearable,
            disabled,
            searchable,
            labelKey,
            valueKey,
            noResultsText,
            placeholder,
            selectedValue,
            options,
            required
        } = this.state;
        return (
            <div id={id ? id : name}>
                <ReactSelect
                    name={name}
                    openOnClick={openOnClick}
                    clearable={clearable}
                    disabled={disabled}
                    searchable={searchable}
                    labelKey={labelKey}
                    valueKey={valueKey}
                    noResultsText={noResultsText}
                    placeholder={placeholder}
                    onChange={this.onChange}
                    onValueClick={(value, event) => {}}
                    value={selectedValue}
                    options={options}
                    required={required}
                />
                {/*Following hidden input is added for parsley validation*/}
                <input
                    type="text"
                    style={{ display: 'none' }}
                    value={selectedValue}
                    readOnly
                    data-parsley-required={required}
                    data-parsley-class-handler={'#' + (id ? id : name)}
                />
            </div>
        );
    }
}

Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    openOnClick: PropTypes.bool,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    searchable: PropTypes.bool,
    labelKey: PropTypes.string,
    valueKey: PropTypes.string,
    noResultsText: PropTypes.string,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.any,
    hasParent: PropTypes.bool,
    parentValue: PropTypes.string,
    required: PropTypes.bool
};

Select.defaultProps = {
    clearable: true,
    disabled: false,
    searchable: true,
    labelKey: 'value',
    valueKey: 'id',
    hasParent: false,
    parentValue: '',
    required: false
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.js